import Vue from 'vue'
import App from './App.vue'
import VueGtag from "vue-gtag";
import vueHeadful from 'vue-headful';
import VueRouter from "vue-router";
import Contact from "@/components/Contact";
import Matchmaking from "@/components/Matchmaking";
import News from "@/components/News";
import MatchmakingAlgorithm from "@/components/MatchmakingAlgorithm";
import HowToEnterNames from "@/components/HowToEnterNames";
import HowToScout from "@/components/HowToScout";
import HowToUse from "@/components/HowToUse";

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'App',
      component: Matchmaking
    },
    {
      path: '/how-to-use',
      name: 'HowToUse',
      component: HowToUse
    },
    {
      path: '/how-to-scout',
      name: 'HowToScout',
      component: HowToScout
    },
    {
      path: '/how-to-enter-names',
      name: 'HowToEnterNames',
      component: HowToEnterNames
    },
    {
      path: '/matchmaking-algorithm',
      name: 'MatchmakingAlgorithm',
      component: MatchmakingAlgorithm
    },
    {
      path: '/news',
      name: 'News',
      component: News
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    }
  ]
})

Vue.config.productionTip = false

Vue.use(VueRouter)

Vue.use(VueGtag, {
  config: { id: "UA-163102735-1" }
}, router)

Vue.use(require('vue-script2'))

Vue.component('vue-headful', vueHeadful)

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
